// The sign-up page no longer creates the account: it only keeps what was typed (name, e-mail, password, the agreements) until a
// plan is chosen on /subscription — that is where the account is really created. Kept in sessionStorage (this tab only,
// gone when the tab closes) and wiped as soon as the account exists.
const KEY = "ms_pending_signup";

export const getPendingSignup = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch { return null; }
};
export const setPendingSignup = (data) => {
  try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch { /* storage unavailable */ }
};
export const clearPendingSignup = () => {
  try { sessionStorage.removeItem(KEY); } catch { /* storage unavailable */ }
};
